import React from 'react'
import EventFormContentTags from './EventFormContentTags'

export default function StepTwoAudienceTags({ step, formData, errorFields, onChange }) {
  return (
    <div className={`${step !== 1 ? 'hidden' : 'block'} md:block`}>
      <fieldset className="form-fieldset">
        <legend className="form-legend">Audience & Tags</legend>
        <p className="text-sm text-muted mb-4">
          Choose who should see your event (e.g., public, members) and add tags like “live music,” “free entry,” or “outdoor” to improve discoverability.
        </p>
        <EventFormContentTags formData={formData} onChange={onChange} errorFields={errorFields} />
      </fieldset>
    </div>
  )
}